import { IImageThumbnail } from '../../../Entities';

let CATEGORY_NORMAL = 1;

type CategoryCounts = {
    deliveredCount: number;
    nonStitchedDeliveredCount: number;
    orderedCount: number;
    extraImageCount: number;
};

export function calculateCategoryCounts(
    images: IImageThumbnail[],
    numberOfImages: number,
    getEffectiveCategory: (image: IImageThumbnail) => number
): CategoryCounts {
    let orderedCount = numberOfImages;

    let deliveredImages = images.filter(function (img) {
        return getEffectiveCategory(img) === CATEGORY_NORMAL;
    });

    let deliveredCount = deliveredImages.length;

    let nonStitchedDeliveredCount = deliveredImages.filter(function (img) {
        return !img.filename.startsWith('Stitched_');
    }).length;

    let extraImageCount = Math.max(0, deliveredCount - orderedCount);

    return { deliveredCount, nonStitchedDeliveredCount, orderedCount, extraImageCount };
}
